module.exports = __webpack_public_path__ + "img/savings-main.77c310e.webp";